<div>
    <span class="value">{{data.value}}</span>
    <p class="text">{{data.text}}</p>
</div>